module.exports = __webpack_public_path__ + "img/MessageCenter.a9735d87.png";